import React from 'react';
import { Row } from 'react-table';

import { footerHeight } from '../../constants';
import { sumFooterValue } from '../../utils';

interface WorkIncludeFooterProps {
    rows: Row<TrqkGapChannelAudio>[];
}

/**
 * Sums and displays the total of all gaps (differences between the performances and detections) for
 * all rows that are currently selected.
 * @param props - {@link WorkIncludeFooterProps}
 */
export function WorkIncludeFooter({
    rows,
}: WorkIncludeFooterProps): JSX.Element {
    const included = sumFooterValue({
        rows,
        sumByFn: (row: Row<TrqkGapChannelAudio>): number => {
            if (row.isSelected) {
                return 1;
            }

            return 0;
        },
    });

    return (
        <p className="flex items-center pl-3" style={{ height: footerHeight }}>
            {included}
        </p>
    );
}
